export default {
    "name": "Product",
    "kind": "HoudiniQuery",
    "hash": "aa4519ef286815d3fcdf36e3a73b490c39542f7bda2f6c79f48364b9eecaca41",

    "raw": `query Product($id: ID, $handle: String, $sdsHandle: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  product(id: $id, handle: $handle) {
    ...ProductRawBaseData
    variants(first: 100) {
      edges {
        node {
          id
          selectedOptions {
            name
            value
          }
          price {
            amount
            currencyCode
          }
          sku: metafield(key: "just_sku", namespace: "sprenger") {
            key
            value
            id
          }
          technical_data: metafield(key: "technical_data", namespace: "sprenger") {
            key
            value
            id
          }
          isArchived: metafield(key: "is_archived", namespace: "sprenger") {
            key
            value
            id
          }
          availableForSale
        }
      }
    }
    id
  }
  sdsProduct: product(handle: $sdsHandle) {
    ...ProductVariantBaseData
    id
  }
}

fragment ProductRawBaseData on Product {
  id
  title
  tags
  totalInventory
  handle
  description
  descriptionHtml
  availableForSale
  priceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
    minVariantPrice {
      amount
      currencyCode
    }
  }
  compareAtPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
    minVariantPrice {
      amount
      currencyCode
    }
  }
  options(first: 10) {
    id
    name
    values
  }
  dreid: metafield(key: "dreid", namespace: "sprenger") {
    key
    value
    id
  }
  metaDescription: metafield(key: "meta_description", namespace: "sprenger") {
    key
    value
    id
  }
  metaTitle: metafield(key: "meta_title", namespace: "sprenger") {
    key
    value
    id
  }
  video: metafield(key: "video", namespace: "sprenger") {
    key
    value
    id
  }
  measure_d2c: metafield(key: "measure_d2c", namespace: "sprenger") {
    key
    value
    id
  }
  upSellSkus: metafield(key: "upsell_skus", namespace: "sprenger") {
    key
    value
    id
  }
  sku: metafield(key: "sku", namespace: "sprenger") {
    key
    value
    id
  }
  is_single: metafield(key: "is_single", namespace: "sprenger") {
    key
    value
    id
  }
  colormap: metafield(key: "colormap", namespace: "sprenger") {
    key
    value
    id
  }
  highlights: metafield(key: "highlights", namespace: "sprenger") {
    key
    value
    id
  }
  image_urls: metafield(key: "image_urls", namespace: "sprenger") {
    key
    value
    id
  }
  bulletPoints: metafield(key: "bullets", namespace: "sprenger") {
    key
    value
    id
  }
  measurement_table: metafield(key: "measurement_table", namespace: "sprenger") {
    key
    value
    id
  }
  crossSellReferences: metafield(
    key: "crosssell_references"
    namespace: "sprenger"
  ) {
    key
    value
    id
  }
  collections(first: 100) {
    edges {
      node {
        title
        handle
        description
        path: metafield(key: "path", namespace: "sprenger") {
          key
          value
          id
        }
        id
      }
    }
  }
  __typename
}

fragment ProductVariantBaseData on Product {
  variants(first: 100) {
    edges {
      node {
        id
        sku: metafield(key: "just_sku", namespace: "sprenger") {
          key
          value
          id
        }
        selectedOptions {
          name
          value
        }
        quantityAvailable
        availableForSale
      }
    }
  }
  id
  __typename
}
`,

    "rootType": "QueryRoot",

    "selection": {
        "fields": {
            "product": {
                "type": "Product",
                "keyRaw": "product(handle: $handle, id: $id)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "tags": {
                            "type": "String",
                            "keyRaw": "tags",
                            "visible": true
                        },

                        "totalInventory": {
                            "type": "Int",
                            "keyRaw": "totalInventory",
                            "nullable": true,
                            "visible": true
                        },

                        "handle": {
                            "type": "String",
                            "keyRaw": "handle",
                            "visible": true
                        },

                        "description": {
                            "type": "String",
                            "keyRaw": "description",
                            "visible": true
                        },

                        "descriptionHtml": {
                            "type": "HTML",
                            "keyRaw": "descriptionHtml",
                            "visible": true
                        },

                        "availableForSale": {
                            "type": "Boolean",
                            "keyRaw": "availableForSale",
                            "visible": true
                        },

                        "priceRange": {
                            "type": "ProductPriceRange",
                            "keyRaw": "priceRange",

                            "selection": {
                                "fields": {
                                    "maxVariantPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "maxVariantPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "minVariantPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "minVariantPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "compareAtPriceRange": {
                            "type": "ProductPriceRange",
                            "keyRaw": "compareAtPriceRange",

                            "selection": {
                                "fields": {
                                    "maxVariantPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "maxVariantPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "minVariantPrice": {
                                        "type": "MoneyV2",
                                        "keyRaw": "minVariantPrice",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Decimal",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currencyCode": {
                                                    "type": "CurrencyCode",
                                                    "keyRaw": "currencyCode",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "options": {
                            "type": "ProductOption",
                            "keyRaw": "options(first: 10)",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "values": {
                                        "type": "String",
                                        "keyRaw": "values",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "dreid": {
                            "type": "Metafield",
                            "keyRaw": "dreid(key: \"dreid\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "metaDescription": {
                            "type": "Metafield",
                            "keyRaw": "metaDescription(key: \"meta_description\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "metaTitle": {
                            "type": "Metafield",
                            "keyRaw": "metaTitle(key: \"meta_title\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "video": {
                            "type": "Metafield",
                            "keyRaw": "video(key: \"video\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "measure_d2c": {
                            "type": "Metafield",
                            "keyRaw": "measure_d2c(key: \"measure_d2c\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "upSellSkus": {
                            "type": "Metafield",
                            "keyRaw": "upSellSkus(key: \"upsell_skus\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "sku": {
                            "type": "Metafield",
                            "keyRaw": "sku(key: \"sku\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "is_single": {
                            "type": "Metafield",
                            "keyRaw": "is_single(key: \"is_single\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "colormap": {
                            "type": "Metafield",
                            "keyRaw": "colormap(key: \"colormap\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "highlights": {
                            "type": "Metafield",
                            "keyRaw": "highlights(key: \"highlights\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "image_urls": {
                            "type": "Metafield",
                            "keyRaw": "image_urls(key: \"image_urls\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "bulletPoints": {
                            "type": "Metafield",
                            "keyRaw": "bulletPoints(key: \"bullets\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "measurement_table": {
                            "type": "Metafield",
                            "keyRaw": "measurement_table(key: \"measurement_table\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "crossSellReferences": {
                            "type": "Metafield",
                            "keyRaw": "crossSellReferences(key: \"crosssell_references\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "collections": {
                            "type": "CollectionConnection",
                            "keyRaw": "collections(first: 100)",

                            "selection": {
                                "fields": {
                                    "edges": {
                                        "type": "CollectionEdge",
                                        "keyRaw": "edges",

                                        "selection": {
                                            "fields": {
                                                "node": {
                                                    "type": "Collection",
                                                    "keyRaw": "node",

                                                    "selection": {
                                                        "fields": {
                                                            "title": {
                                                                "type": "String",
                                                                "keyRaw": "title",
                                                                "visible": true
                                                            },

                                                            "handle": {
                                                                "type": "String",
                                                                "keyRaw": "handle",
                                                                "visible": true
                                                            },

                                                            "description": {
                                                                "type": "String",
                                                                "keyRaw": "description",
                                                                "visible": true
                                                            },

                                                            "path": {
                                                                "type": "Metafield",
                                                                "keyRaw": "path(key: \"path\", namespace: \"sprenger\")",
                                                                "nullable": true,

                                                                "selection": {
                                                                    "fields": {
                                                                        "key": {
                                                                            "type": "String",
                                                                            "keyRaw": "key",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "ID",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        },

                        "variants": {
                            "type": "ProductVariantConnection",
                            "keyRaw": "variants(first: 100)",

                            "selection": {
                                "fields": {
                                    "edges": {
                                        "type": "ProductVariantEdge",
                                        "keyRaw": "edges",

                                        "selection": {
                                            "fields": {
                                                "node": {
                                                    "type": "ProductVariant",
                                                    "keyRaw": "node",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "ID",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "selectedOptions": {
                                                                "type": "SelectedOption",
                                                                "keyRaw": "selectedOptions",

                                                                "selection": {
                                                                    "fields": {
                                                                        "name": {
                                                                            "type": "String",
                                                                            "keyRaw": "name",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "price": {
                                                                "type": "MoneyV2",
                                                                "keyRaw": "price",

                                                                "selection": {
                                                                    "fields": {
                                                                        "amount": {
                                                                            "type": "Decimal",
                                                                            "keyRaw": "amount",
                                                                            "visible": true
                                                                        },

                                                                        "currencyCode": {
                                                                            "type": "CurrencyCode",
                                                                            "keyRaw": "currencyCode",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "sku": {
                                                                "type": "Metafield",
                                                                "keyRaw": "sku(key: \"just_sku\", namespace: \"sprenger\")",
                                                                "nullable": true,

                                                                "selection": {
                                                                    "fields": {
                                                                        "key": {
                                                                            "type": "String",
                                                                            "keyRaw": "key",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "technical_data": {
                                                                "type": "Metafield",
                                                                "keyRaw": "technical_data(key: \"technical_data\", namespace: \"sprenger\")",
                                                                "nullable": true,

                                                                "selection": {
                                                                    "fields": {
                                                                        "key": {
                                                                            "type": "String",
                                                                            "keyRaw": "key",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "isArchived": {
                                                                "type": "Metafield",
                                                                "keyRaw": "isArchived(key: \"is_archived\", namespace: \"sprenger\")",
                                                                "nullable": true,

                                                                "selection": {
                                                                    "fields": {
                                                                        "key": {
                                                                            "type": "String",
                                                                            "keyRaw": "key",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "availableForSale": {
                                                                "type": "Boolean",
                                                                "keyRaw": "availableForSale",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    },

                    "fragments": {
                        "ProductRawBaseData": {
                            "arguments": {}
                        }
                    }
                },

                "visible": true
            },

            "sdsProduct": {
                "type": "Product",
                "keyRaw": "sdsProduct(handle: $sdsHandle)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "variants": {
                            "type": "ProductVariantConnection",
                            "keyRaw": "variants(first: 100)",

                            "selection": {
                                "fields": {
                                    "edges": {
                                        "type": "ProductVariantEdge",
                                        "keyRaw": "edges",

                                        "selection": {
                                            "fields": {
                                                "node": {
                                                    "type": "ProductVariant",
                                                    "keyRaw": "node",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "ID",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "sku": {
                                                                "type": "Metafield",
                                                                "keyRaw": "sku(key: \"just_sku\", namespace: \"sprenger\")",
                                                                "nullable": true,

                                                                "selection": {
                                                                    "fields": {
                                                                        "key": {
                                                                            "type": "String",
                                                                            "keyRaw": "key",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "selectedOptions": {
                                                                "type": "SelectedOption",
                                                                "keyRaw": "selectedOptions",

                                                                "selection": {
                                                                    "fields": {
                                                                        "name": {
                                                                            "type": "String",
                                                                            "keyRaw": "name",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "quantityAvailable": {
                                                                "type": "Int",
                                                                "keyRaw": "quantityAvailable",
                                                                "nullable": true,
                                                                "visible": true
                                                            },

                                                            "availableForSale": {
                                                                "type": "Boolean",
                                                                "keyRaw": "availableForSale",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    },

                    "fragments": {
                        "ProductVariantBaseData": {
                            "arguments": {}
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "id": "ID",
            "handle": "String",
            "sdsHandle": "String",
            "country": "CountryCode",
            "language": "LanguageCode"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=7b7b439fed1e10f88b2a26c8e167e24c5aaf5dc9a448b169a384a9b97cd4638f";